export default {
  default: () => import("/home/runner/work/tripexpert-frontend/tripexpert-frontend/layouts/default.vue").then(m => m.default || m)
}